// u.jic.io FACE Registry 客户端:短名字 ↔ 活体人脸模板 ↔ 0x 收款地址。
// 匹配在服务端完成(上传 128 维描述子,服务端算距离),模板全库不下发。
const JIC_URL = "https://u.jic.io";

export type FaceIdentity = {
  type: "jic" | "address" | "x" | "email" | "phone";
  value: string;
  method: string;
  verifiedAt: string;
};

export type ServerFaceRecord = {
  address: string;
  name: string;
  method: string;
  enrolledAt: string;
  updatedAt: string;
  identities?: FaceIdentity[];
};

export type ServerFaceMatch = ServerFaceRecord & {
  distance: number;
  confidence: number;
};

export async function bindFaceOnServer(
  descriptor: number[],
  jwt: string,
  method = "face-mesh-challenge-v0"
): Promise<{ ok: boolean; record?: ServerFaceRecord; error?: string; boundTo?: string }> {
  const response = await fetch(`${JIC_URL}/v1/face/bind`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${jwt}` },
    body: JSON.stringify({ descriptor, method }),
  });
  return (await response.json()) as { ok: boolean; record?: ServerFaceRecord; error?: string; boundTo?: string };
}

export async function resolveFaceOnServer(
  descriptor: number[]
): Promise<{ match: ServerFaceMatch | null; count: number } | null> {
  try {
    const response = await fetch(`${JIC_URL}/v1/face/resolve`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ descriptor }),
    });
    const data = (await response.json()) as { ok?: boolean; match?: ServerFaceMatch | null; count?: number };
    if (!data.ok) return null;
    return { match: data.match || null, count: data.count || 0 };
  } catch {
    return null; // 离线或服务端不可用:调用方回退本机 Registry
  }
}

export async function fetchFaceStatus(
  nameOrAddress: string
): Promise<{ bound: boolean; record?: ServerFaceRecord } | null> {
  try {
    const response = await fetch(`${JIC_URL}/v1/face/status/${encodeURIComponent(nameOrAddress)}`);
    return (await response.json()) as { bound: boolean; record?: ServerFaceRecord };
  } catch {
    return null;
  }
}

export async function fetchFaceStats(): Promise<number | null> {
  try {
    const response = await fetch(`${JIC_URL}/v1/face/stats`);
    const data = (await response.json()) as { count?: number };
    return typeof data.count === "number" ? data.count : null;
  } catch {
    return null;
  }
}

export async function resolveHandleAddress(name: string): Promise<string | null> {
  try {
    const response = await fetch(`${JIC_URL}/v1/handle/resolve/${encodeURIComponent(name)}`);
    const data = (await response.json()) as { ok?: boolean; address?: string };
    return data.ok && data.address ? data.address.toLowerCase() : null;
  } catch {
    return null;
  }
}
